const brands = [{ domain: 'qspark.trade', title: 'qSpark', logo: 'qspark-logo.png', theme: 'g100' }];
const defaultBrand = { title: 'MayStreet', logo: 'maystreet-logo.png', theme: 'white' };

// branding is based on the hostname instead of the organization, as the user is not logged in yet
export const brand = brands.find((brand) => window.location.hostname.endsWith(brand.domain)) ?? defaultBrand;
